class baseException {
    constructor(val) {
        this.val = val
    }
    toString() {
        return this.val
    }
}

export class NotImplementedError extends baseException {}

export class ValueError extends baseException {}

export class ValidationError extends baseException{}